<template>
    <div>
      <v-container
                fluid
                class="p-0"
        >
            <v-toolbar class="ex-toolbar-fixed p-0-36">
                <v-layout row wrap class="align-center">
                    <transition name="component-fade">
                      <v-flex xs12 class="nav-mobile-search" v-if="mobileSearch">
                        <v-toolbar-items class="ex-filter-menu">
                          <main-search ref="searchMainMob"/>
                          <search-individual-components ref="mobSearchField"/>
                          <button @click="openMobileSearch" class="cancel-btn"><i class="icon-cancel"/></button>
                        </v-toolbar-items>
                      </v-flex>
                    </transition>

                    <v-flex xs7 md4 lg2 class="nav-logo-base">
                        <v-toolbar-title class="">
                          <router-link to="/">   <i class="g-brand"/></router-link>
                            <div class="g-full-logo">
                                <router-link to="/">
                              <img src="../../assets/images/GIVER.svg" class="g-brand-giver" alt="Giver logo"></router-link>
                                <span class="nav-slogan">{{$t('header.logo_slogan')}}</span>
                            </div>
                        </v-toolbar-title>
                    </v-flex>
                    <v-flex xs5 class="nav-mobile-controls hidden-md-and-up">
                      <v-layout row wrap justify-end>
                        <v-flex class="nav-mobile-menu">
                          <span class="icon-magnifying-glass"
                                @click="openMobileSearch"
                          />
                        </v-flex>
                        <v-flex class="nav-mobile-menu" :class="{ active: isActive, 'hasNotif': newNotificationsCount }">
                            <span class="icon-mobile-menu"
                                  @click="openNav"
                            />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex sm12 md6 lg2 class="ex-search-space">
                        <v-toolbar-items class="ex-filter-menu">

                            <main-search ref="searchMain"/>
                            <search-individual-components/>
                        </v-toolbar-items>
                    </v-flex>
                    <v-flex md2 class="hidden-sm-and-down hidden-lg-and-up">
                        <v-flex class="nav-mobile-menu d-flex justify-end" :class="{ active: isActive, 'hasNotif': newNotificationsCount }">
                               <span class="icon-mobile-menu ex-mobile-menu"
                                     @click="openNav"
                               />
                        </v-flex>
                    </v-flex>
                    <v-flex lg5 class="hidden-md-and-down">
                      <div class="g-header-links d-flex justify-end">
                        <v-btn class="ex-hover-effect" flat v-if="false">{{$t('headers.givers')}}</v-btn>
                        <v-btn class="ex-hover-effect" flat v-if="false">{{$t('headers.receivers')}}</v-btn>

                        <router-link active-class="activemenu" class="hover-effect" to="/products">
                          <v-btn @click="productPage()" flat>
                            {{$t('headers.gifts')}}
                          </v-btn>
                        </router-link>
                        <router-link active-class="activemenu" class="hover-effect" to="/needs">
                          <v-btn flat>
                            {{$t('headers.needs')}}
                          </v-btn>
                        </router-link>

                        <router-link active-class="activemenu" class="hover-effect" exact to="/about">
                          <v-btn flat>
                            {{$t('headers.about_us')}}
                          </v-btn>
                        </router-link>

                        <router-link active-class="activemenu" class="hover-effect" exact to="/contact">
                          <v-btn  flat>
                            {{$t('headers.get_in_touch')}}
                          </v-btn>
                        </router-link>

                        <router-link active-class="activemenu" class="hover-effect" exact to="/donation">
                          <v-btn @click="getInTouchPage()" flat>
                            {{$t('headers.donation')}}
                            <i class="donate-icon"/>
                          </v-btn>
                        </router-link>
                      </div>
                    </v-flex>
                    <v-flex lg3 class="hidden-md-and-down">
                        <v-layout class="d-flex justify-end align-center w-100 h-100">
                            <!--Sign in, Sign Up Buttons-->
                            <v-toolbar-items v-if="!isLogged" class="d-flex justify-end w-80">
                                <v-btn class="g-btn-default g-btn-135 m-0-5" @click.prevent="openRegistrationModal()">{{ $t('sign_up') }}</v-btn>
                                <v-btn class="g-btn-main g-btn-135 m-0-5" @click.prevent="openLoginModal()">{{ $t('sign_in') }}</v-btn>
                            </v-toolbar-items>

                            <!--User Menu-->
                            <v-toolbar-items v-else-if="isLogged" class="d-flex justify-end" id="exAvatarList">
                                <v-menu
                                        attach="#exAvatarList"
                                        v-model="userMenu.isActive"
                                        open-on-click
                                        transition="slide-y-transition"
                                        offset-y
                                        bottom
                                        class="ex-avatar-border icon-angle-down-18 w-100"
                                >
                                    <v-avatar slot="activator"
                                              size="100%"
                                              :class="{'hasNotif': newNotificationsCount}"
                                              class="ex-avatar">
                                        <img v-if="signUpData.image"
                                             :src=" apiUrl+ signUpData.image"
                                             class="ex-avatar-img"
                                             :alt="$t('avatar')"/>
                                        <img v-else
                                             src="../../../src/assets/images/for-edit-profile.svg"
                                             :alt="$t('avatar')"
                                             class="ex-avatar-icon">
                                        <span v-if="signUpData.lastName != null"
                                              class="ex-user-name">
                                            {{signUpData.firstName[0] +  "." + " " + signUpData.lastName}}
                                        </span>
                                        <span v-else
                                                class="ex-user-name"
                                                :name="signUpData.firstName"
                                          >{{signUpData.firstName}}</span>
                                    </v-avatar>
                                    <v-list class="ex-avatar-list">
                                        <v-list-tile
                                                v-for="(item, index) in menuListItems"
                                                :key="index"
                                                @click="profileStaticFunction($event, item.path, item.tabRoute)">
                                            <v-list-tile-avatar>
                                              <v-icon>
                                                {{item.icon}}
                                              </v-icon>
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                              <v-list-tile-title v-html="$t(item.title)"/>
                                            </v-list-tile-content>

                                            <v-list-tile-action v-if="item.title === 'notifications' && newNotificationsCount">
                                              <v-badge left color="red">
                                                <span slot="badge">{{newNotificationsCount}}</span>
                                              </v-badge>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-toolbar-items>

                            <!--Language Dropdown-->
                          <language :attacheId="'exLanguageListMDesktop'"/>
                            <!--<v-toolbar-items class="justify-center w-15 m-l-10" id="exLanguageList">
                                <v-menu class="g-language-select"
                                        attach="#exLanguageList"
                                        transition="slide-y-transition"
                                >
                                    <v-flex slot="activator"
                                            class="d-flex justify-center align-center">
                                        <i :class="langIcon"></i>
                                        <i class="icon-angle-down-18 ml-2"></i>
                                    </v-flex>
                                    <v-list>
                                        <v-list-tile
                                                v-for="(language, index) in languages"
                                                :key="index"
                                                @click="setLang(language)">
                                            <v-list-tile-title>{{ language.name }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-toolbar-items>-->
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-toolbar>
        </v-container>
        <!--Registration Modal-->
        <v-dialog content-class="vdialognew" class="ex-dialog register-dialog" v-model="dialog"  max-width="550px">
          <div class="modal-scroll">
          <v-layout class="g-cancel-btn">
            <v-btn
              class="ex-v-btn ex-close-btn"
              :ripple="false"
              @click.native="closeRegForm">
              <i class="icon-cancel"></i>
            </v-btn>
          </v-layout>
          <v-layout class="container-fluid" row wrap v-if="!regModalAlert.isConfirmEmail">
            <v-flex d-flex xs6>
              <h2  style="color: black"  class="g-registration ml-5">{{ $t('sign_up') }}</h2>
            </v-flex>
            <v-flex d-flex xs6 style="background: linear-gradient(274.11deg, #6240D9 4.7%, #5290DF 99.19%); height: 83px!important;">
              <h2 style="cursor: pointer" class="g-registration ml-5"> <span class="m-0-5"
                                                                             @click.prevent="openLoginModal()">{{$t('sign_in')}}</span></h2>
            </v-flex>
          </v-layout>
            <v-card-title class="login-alerts-and-socials register-sect">
              <p  v-if="!regModalAlert.isConfirmEmail" class="with mt-2">{{$t('with')}}</p>
            <v-layout v-if="!regModalAlert.isConfirmEmail" class="justify-center g-social-icons registration-mode">
                <div class="g-icon-style  sign-in-modal1">
                    <a :href="`${apiUrl}/api/auth/google`">
                        <img src="../../assets/images/g.png" alt="">
                    </a>
                </div>
                <div class="g-icon-style sign-in-modal2">
                    <a :href="`${apiUrl}/api/auth/facebook`">
                        <img src="../../assets/images/fb.svg" alt="">
                    </a>
                </div>
            </v-layout>
              <p v-if="!regModalAlert.isConfirmEmail" class="hr"><span>{{$t('or')}}</span></p>
              <v-layout v-if="!regModalAlert.isConfirmEmail" row wrap class="reg-data" style="letter-spacing: 1px">
                <v-flex d-flex>
                  <a class="comp-or-user" :class="regData.comp ? 'addActive' : 'deActive'" @click="selectRegPerson">{{$t('person')}} </a>
                  <span class="comp-or-user" style="color: black; font-size: 18px;"> / </span>
              <div v-if="hideCompany" class="cond-term-checkbox">
                <label class="container-checkbox-comp">
                  <a  class="comp-or-user" :class="regData.comp ? 'deActive' : 'addActive'">{{$t('company_registration')}}</a>
                  <input type="checkbox" v-model="regData.comp">
                </label>
              </div>
                </v-flex>
              </v-layout>
                <v-alert :value="regModalAlert.value" :type="regModalAlert.type">
                    <v-icon v-if="regModalAlert.type === 'success'" class="accept-icon-alert">icon-accept</v-icon>
                    <v-icon v-else-if="regModalAlert.type === 'error'" class="remove-icon-alert">icon-combined-shape-1</v-icon>
                    <p v-html="regModalAlert.text"></p>
                </v-alert>
            </v-card-title>
            <v-card class="ex-card-content ex-register-content ex-height-scroll">
                <v-card-text v-if="!regModalAlert.isConfirmEmail">
                    <v-container grid-list-md>
                        <!--<p class="g-info-title text-xs-center">{{ $t('there_are_many_variations') }}</p>-->
                        <v-layout wrap>
                            <v-form
                                    class="w-100"
                                    ref="form"
                                    lazy-validation
                            >
                              <v-flex xs12>
                                <v-text-field
                                  prepend-inner-icon="person"
                                  solo
                                  outlined
                                  class="solo input-icons"
                                  v-if="regData.comp"
                                  :class="{'invalid-field': this.regModalAlert.value && !this.regData.firstName}"
                                  @keypress="enterKeyPressRegistration"
                                  :placeholder="$t('company')"
                                  v-model="regData.companyName"
                                  :rules="companyNameRules"
                                >
                                </v-text-field>
                                <p  v-if="regData.comp" style="color:red"> {{errors.companyNameError}}</p>
                                <span></span>
                              </v-flex>
                              <v-flex xs12 class="group-name-input">
                                <v-text-field
                                  prepend-inner-icon="phone"
                                  solo
                                  outlined
                                  class="solo input-icons"
                                  v-if="regData.comp"
                                  v-model="regData.phoneNumber"
                                  placeholder="+374XXXXXXXX"
                                  :rules="phoneNumberRules"
                                  required>
                                </v-text-field>
                                <p  v-if="regData.comp" style="color:red"> {{errors.phoneNumberError}}</p>
                              </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                    v-if="!regData.comp"
                                    prepend-inner-icon="person"
                                    solo
                                    outlined
                                            class="solo input-icons"
                                            :class="{'invalid-field': this.regModalAlert.value && !this.regData.firstName}"
                                            @keypress="enterKeyPressRegistration"
                                            :placeholder="$t('first_name')"
                                            v-model="regData.firstName"
                                            :rules="nameRules"
                                    >
                                    </v-text-field>
                                  <p style="color:red"> {{errors.firstNameError}}</p>
                                    <span></span>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                      prepend-inner-icon="person"
                                      solo
                                      outlined
                                      class="solo input-icons"
                                            v-if="!regData.comp"
                                            @keypress="enterKeyPressRegistration"
                                            :placeholder="$t('last_name')"
                                            v-model="regData.lastName"
                                            :rules="lastNameRules"
                                    >
                                    </v-text-field>
                                  <p style="color:red"> {{errors.lastNameError}}</p>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                      prepend-inner-icon="person"
                                      solo
                                      outlined
                                      class="solo input-icons"
                                            @keyup="makeToLowerCaseRegister"
                                            @keypress="enterKeyPressRegistration"
                                            :placeholder="$t('email')"
                                            v-model="regData.email"
                                            :rules="exEmailRules"
                                    >
                                    </v-text-field>
                                  <p style="color:red"> {{errors.emailError}}</p>
                                </v-flex>
                              <v-flex ls12>
                                <v-text-field
                                  class="solo input-icons"
                                  prepend-inner-icon="lock"
                                  solo
                                  outlined
                                  @keypress="enterKeyPressRegistration"
                                  v-model="regData.password"
                                  :rules="accoundPasswordReg"
                                  :placeholder="$t('password')"
                                  required
                                  :type="showPassword ? 'text' : 'password'"
                                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                  @click:append="showPassword = !showPassword"
                                ></v-text-field>
                                <p style="color:red"> {{errors.passwordError}}</p>
                              </v-flex>
                                <v-flex xs12 class="password-conf-input-sect">
                                    <v-text-field ref="confirmConfirm"
                                                  prepend-inner-icon="lock"
                                                  solo
                                                  outlined
                                                  class="solo input-icons"
                                                  @keypress="enterKeyPressRegistration"
                                                  :placeholder="$t('confirm_password')"
                                                  v-model="regData.password_confirmation"
                                                  :rules="confirmPassword"
                                                  :type="showPasswordConf ? 'text' : 'password'"
                                                  :append-icon="showPasswordConf ? 'visibility' : 'visibility_off'"
                                                  @click:append="showPasswordConf = !showPasswordConf"
                                    >
                                    </v-text-field>
                                </v-flex>
                              <div class="d-flex justify-content-between terms cond-term-checkbox">
                                <label class="container-checkbox">
                               <input type="checkbox" class="checkbox"  id="checkbox" ref="checkbox" v-model="regData.checkbox" @change="checked($event)">
                                <span class="ml-1 agree">{{$t('agree')}} </span><a><router-link to="/terms-and-conditions" target="_blank" class="ml-2 one" exact>
                                    {{$t('termsss')}}</router-link></a>
                                  <span class="checkmark"></span>
                                </label>
                              </div>
                              <span class="mt-5 ml-4 pl-1 errormessage">{{ckderror}}</span>
                              <!--need to allow choose user or company roles in the future-->
                                <v-flex xs12 v-if="false">
                                    <v-select
                                            :items="roles"
                                            name="name"
                                            item-text="name"
                                            :label="$t('role')"
                                            v-model="regData.role"
                                    />
                                </v-flex>
                            </v-form>
                        </v-layout>
                    </v-container>
                    <!--<small>*indicates required field</small>-->
                </v-card-text>
            </v-card>
            <v-card-actions class="ex-card-actions" v-if="!regModalAlert.isConfirmEmail">
                <v-layout class="ex-card-actions-content justify-center align-center" column>
                    <v-btn class="g-btn-main g-big-btn g-btn-register" :ripple="false" flat @click="signUp(), regValidate()">{{ $t('sign_up') }}</v-btn>
                    <p class="m25-0 ex-info-text">{{ $t('already_have_an_account') }}
                      <span class="m-0-5 deActive" @click.prevent="openLoginModal()">{{$t('sign_in')}}</span>
                    </p>
                </v-layout>
            </v-card-actions>
          </div>
        </v-dialog>
        <!--Login Modal-->
        <v-dialog content-class="vdialognew" class="ex-dialog" v-model="loginModal" persistent max-width="550px">
          <div class="modal-scroll">
          <v-layout class="g-cancel-btn">
            <v-btn
              class="ex-v-btn ex-close-btn"
              :ripple="false"
              @click.native="closeLoginForm">
              <i class="icon-cancel"></i>
            </v-btn>
          </v-layout>
                <v-layout class="container-fluid reg" row wrap>
                  <v-flex d-flex xs6 style="background: linear-gradient(274.11deg, #6240D9 4.7%, #5290DF 99.19%);height: 83px!important;">
                    <h2 style="cursor: pointer" class="g-registration ml-5"> <span class="m-0-5"
                                                           @click.prevent="openRegistrationModal()">{{$t('sign_up')}}</span></h2>
                  </v-flex>
                  <v-flex d-flex xs6>
                    <h2 style="color: black" class="g-registration ml-5">{{ $t('sign_in') }}</h2>
                  </v-flex>
                    </v-layout>
            <v-card-title class="login-alerts-and-socials">
              <p class="mt-2 with">{{$t('with')}}</p>
                <v-layout class="justify-center g-social-icons mb-5">
                    <div class="g-icon-style sign-in-modal1">
                        <a :href="`${apiUrl}/api/auth/google`">
                            <img src="../../assets/images/g.png" alt="">
                        </a>
                    </div>
                    <div class="g-icon-style sign-in-modal2">
                        <a :href="`${apiUrl}/api/auth/facebook`">
                            <img src="../../assets/images/fb.svg" alt="">
                        </a>
                    </div>
                </v-layout>
              <p class="hr"><span>{{$t('or')}}</span></p>
                <v-alert class="mr-2" :value="loginModalAlert.value" :type="loginModalAlert.type">
                    <v-icon v-if="loginModalAlert.type === 'error'" class="remove-icon-alert">icon-combined-shape-1</v-icon>
                    {{loginModalAlert.text}}
                </v-alert>
              <div  v-if="showSend" class="justify-center ml-5">
               <span class="ml-3">{{$t('check_spam')}}</span>
                <a onmouseout='this.style.textDecoration="none"'
                   onmouseover='this.style.textDecoration="underline"' @click.prevent="confirmationResend">{{$t('click')}}</a>
                <span class="mr-4">{{$t('resend')}}</span>
              </div>
                <v-alert v-if="showRequestAlert" :value="true"  type="info">
                    <div class="info-icon">

                    </div>
                    <p>{{ $t('header.product_request_alert')}}
                        <a href="" @click.prevent="openRegistrationModal(); loginModal = false">
                          {{$t('header.register_simply')}}</a>
                    </p>
                </v-alert>
            </v-card-title>
            <v-card class="ex-card-content ex-login-content">
                <v-card-text>
                    <v-container grid-list-md>
                        <!--<p class="g-info-title text-xs-center">{{ $t('there_are_many_variations_2') }}</p>-->
                        <v-layout wrap>
                            <v-form
                                    class="w-100"
                                    ref="formLogin"
                                    lazy-validation
                            >
                                <v-flex xs12>
                                    <v-text-field
                                      prepend-inner-icon="person"
                                           class="solo input-icons"
                                           solo
                                           outlined
                                            @keyup="makeToLowerCaseLogin"
                                            @keypress="enterKeyPressLogin"
                                            v-model="logEmail"
                                            :placeholder="$t('email')"
                                            :rules="exEmailRulesLogin"
                                            required>
                                    </v-text-field>
                                  <p style="color: red">{{loginErrors.emailError}}</p>
                                </v-flex>
                                <v-flex ls12>
                                  <v-text-field
                                    prepend-inner-icon="lock"
                                    class="solo input-icons"
                                    solo
                                    outlined
                                    @keypress="enterKeyPressLogin"
                                    v-model="logPass"
                                    :rules="accoundPassword"
                                    :placeholder="$t('password')"
                                    ref="logPass"
                                    required
                                    :type="showPassword ? 'text' : 'password'"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    @click:append="showPassword = !showPassword"
                                  ></v-text-field>
                                  <p style="color: red">{{loginErrors.passwordError}}</p>
                                </v-flex>
                            </v-form>
                            <v-layout class="row justify-space-between align-center ex-column p20-0">
                                <v-checkbox
                                        v-model="rememberMe"
                                        :label=" $t('remember_me')"
                                        :value="false"
                                        class="remember-me-checkbox-sect"
                                />
                                <p class="forgot-password-p" @click.prevent="forgotPasswordModal()">
                                    {{$t('forgot_password')}}</p>
                            </v-layout>
                        </v-layout>
                    </v-container>
                    <!--<small>*indicates required field</small>-->
                </v-card-text>
            </v-card>
            <v-card-actions class="ex-card-actions ex-login-action">
                <v-layout class="justify-center align-center" column>
                    <v-spacer></v-spacer>
                    <v-btn class="g-btn-main-light g-big-btn g-btn-sign" flat :ripple="false" @click.native="signIn(), logValidate()"
                           v-if="!loginModalAlert.isConfirmEmail">{{ $t('sign_in') }}
                    </v-btn>
                    <p class="m25-0 ex-info-text">{{ $t('not_have_an_account_yet') }}<span class="m-0-5 deActive"
                                                                                           @click.prevent="openRegistrationModal()">{{$t('sign_up')}}</span>
                    </p>
                </v-layout>
            </v-card-actions>
          </div>
        </v-dialog>
        <!--Forgot password Modal-->
        <v-dialog class="ex-dialog" v-model="forgotModal" max-width="500px">
            <v-card class="forgot-password-modal">
                <v-card-title class="justify-center m25-auto">
                    <h3 class="g-registration m-0 f-s-22">{{ $t('forgot_password') }}</h3>
                </v-card-title>
                <v-card-text class="login-alerts-and-socials">
                    <v-alert class="mr-2" :value="loginModalAlert.value" :type="loginModalAlert.type">
                      <v-icon v-if="loginModalAlert.type === 'error'" class="remove-icon-alert">icon-combined-shape-1</v-icon>
                      {{loginModalAlert.text}}
                    </v-alert>
                    <v-container grid-list-md>
                        <v-form
                                ref="formForgot"
                                lazy-validation
                        >
                            <v-text-field
                                    class="ex-input-group"
                                    @keypress="enterKeyPressForgotPassword"
                                    v-model="forgotPasswordInputText"
                                    :placeholder="$t('email')"
                                    :rules="exEmailRules"
                                    required>
                            </v-text-field>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions class="p-0-35 m25-auto password-btn-sect">
                    <div
                            class="loading-parent"
                            v-if="loading"
                    >
                        <v-icon v-show="loading">fa fa-spinner fa-spin</v-icon>
                    </div>
                    <div v-if="!loading" class="d-flex justify-center">
                        <v-btn class="cancel-forg-pass-btn" flat @click="backLoginModal" :ripple="false">{{ $t('back') }}</v-btn>
                        <v-btn class="accept-forg-pass-btn" flat @click="forgotPasswordEmailCheck(),forgotValidate()" :ripple="false">{{ $t('send')
                            }}
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--New Password Modal-->
        <v-dialog class="ex-dialog" v-model="modalNewPassword" persistent max-width="500px">
            <v-card class="no-shadow">
                <v-card-title class="justify-center">
                    <p class="g-registration">{{ $t('modal_forgot_new_password') }}</p>
                </v-card-title>
                <v-card-text class="p-0-35">
                    <v-alert :value="loginModalAlert.value" :type="loginModalAlert.type">
                        {{loginModalAlert.text}}
                    </v-alert>
                    <v-container grid-list-md>
                        <v-form
                                ref="formForgotPassword"
                                lazy-validation
                        >
                            <v-text-field
                                    class="ex-input-group"
                                    @keypress="enterSendModalNewPasswordInfo"
                                    type="password"
                                    :placeholder="$t('new_password')"
                                    v-model="newPassword"
                                    :rules="accoundPasswordReg"
                                    required>
                            </v-text-field>
                            <v-text-field
                                    class="ex-input-group"
                                    @keypress="enterSendModalNewPasswordInfo"
                                    type="password"
                                    :placeholder="$t('confirm_password')"
                                    v-model="confirmNewPassword"
                                    :rules="confirmPassword2"
                                    required>
                            </v-text-field>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions class="p-0-35 m25-0 mb-25">
                    <v-spacer></v-spacer>
                    <v-btn class="g-btn-default g-btn-135" flat @click.native="closeModalNewPasswordInfo">{{ $t('close') }}
                    </v-btn>
                    <v-btn class="g-btn-main-light g-btn-135" flat @click="sendModalNewPasswordInfo(), forgotPasswordValidate()">{{ $t('send') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Mobile Sidebar-->
        <v-layout class="ex-left-menu" :class="sideBarStatus" ref="mobileSidebar">
          <!--Language Dropdown-->
          <v-toolbar-items class="justify-center m-l-10" id="exLanguageListMobile">
            <v-menu class="g-language-select"
                    attach="#exLanguageListMobile"
                    transition="slide-y-transition"
            >
              <v-flex slot="activator"
                      class="d-flex justify-center align-center">
                <i :class="langIcon" class="mr-2"></i>
                {{ langName }}
                <i class="icon-angle-down-18 ml-2"></i>
              </v-flex>
              <v-list>
                <v-list-tile
                  v-for="(language, index) in languages"
                  :key="index"
                  @click="setLang(language)">
                  <v-list-tile-title>{{ language.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar-items>
          <v-flex xs12 >
            <v-toolbar-items v-if="!isLogged" class="hidden-sm-and-down d-flex ex-flex-col">
              <v-btn class="g-btn-default g-middle-btn m20-auto" @click.prevent="openRegistrationModal()">
                {{$t('registration') }}
              </v-btn>
              <v-btn class="g-btn-main g-middle-btn m20-auto" @click.prevent="openLoginModal()">{{ $t('sign_in') }}
              </v-btn>
              <v-list class="nav-mobile">
                <ul class="nav-links">
                  <li><a class="nav-link d-none">{{$t('headers.givers')}}</a></li>
                  <li><a class="nav-link d-none">{{$t('headers.receivers')}}</a></li>
                  <li><a class="nav-link" @click="productPage()">{{$t('headers.gifts')}}</a></li>
                  <li><a class="nav-link" @click="$router.push('/needs');closeNav()">{{$t('headers.needs')}}</a></li>
                  <li><a class="nav-link" @click="$router.push('/about');closeNav()">{{$t('headers.about_us')}}</a></li>
                  <li><a class="nav-link" @click="$router.push('/contact');closeNav()">{{$t('headers.get_in_touch')}}</a></li>
                  <li>
                    <a class="nav-link" @click="$router.push('/donation');closeNav()">
                      {{$t('headers.donation')}}
                      <i class="donate-icon"/>
                    </a>
                  </li>
                </ul>
              </v-list>
            </v-toolbar-items>
            <v-toolbar-items v-else-if="isLogged" class="d-block ex-avatar-border" @click="closeNav">
              <div class="ex-avatar">
                <img v-if="signUpData.image"
                     :src=" apiUrl+ signUpData.image"
                     class="ex-avatar-img"
                     alt=""/>
                <img v-else
                     src="../../../src/assets/images/for-edit-profile.svg"
                     :alt="$t('avatar')"
                     class="ex-avatar-icon">
                <span v-if="signUpData.lastName != null"
                      class="ex-user-name">
                    {{signUpData.firstName[0] +  "." + " " + signUpData.lastName}}
                </span>
                <span v-else
                      class="ex-user-name">
                    {{signUpData.firstName}}
                </span>
              </div>
              <v-list class="nav-mobile">
                <v-list-tile
                  v-for="(item, index) in menuListItems"
                  :key="index"
                  @click="profileStaticFunction($event, item.path, item.tabRoute)">
                  <v-icon>
                    {{item.icon}}
                  </v-icon>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="$t(item.title)"></v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action v-if="item.count">
                    <v-badge left color="red">
                      <span slot="badge">{{item.count}}</span>
                    </v-badge>
                  </v-list-tile-action>
                </v-list-tile>
                <ul class="nav-links">
                  <li><a class="nav-link d-none">{{$t('headers.givers')}}</a></li>
                  <li><a class="nav-link d-none">{{$t('headers.receivers')}}</a></li>
                  <li><a class="nav-link" @click="productPage()">{{$t('headers.gifts')}}</a></li>
                  <li><a class="nav-link" @click="$router.push('/needs')">{{$t('headers.needs')}}</a></li>
                  <li><a class="nav-link" @click="$router.push('/about')">{{$t('headers.about_us')}}</a></li>
                  <li><a class="nav-link" @click="$router.push('/contact')">{{$t('headers.get_in_touch')}}</a></li>
                  <li>
                    <a class="nav-link" @click="$router.push('/donation')">{{$t('headers.donation')}}<i class="donate-icon"/></a>
                  </li>
                </ul>
              </v-list>
            </v-toolbar-items>
          </v-flex>
        </v-layout>

        <!--Overlay-->
        <transition name="component-fade">
          <div v-if="userMenu.isActive || getFilterStatus() || sideBarStatus.opened" @mousedown="closeNav" class="primary-overlay"></div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import { EventBus } from '../../event-bus'
import { setAuthHeader } from '../../axiosApi'
import { validateEmail } from '../../helpers/main'
import mainSearch from '../categories/mainSearch'
import SearchIndividualComponents from './components/SearchIndividualProducts'
import Language from './Language'
function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}
export default {
  name: 'Header',
  components: {
    mainSearch,
    SearchIndividualComponents,
    Language
  },
  props: ['showRegistrationModal', 'showLoginModal', 'settings', 'productRequestAlert'],
  data: () => ({
    errors: {},
    loginErrors: {},
    locked: false,
    showPassword: false,
    showPasswordConf: false,
    hideCompany: true,
    showSend: false,
    ckderror: '',
    isActived: false,
    rememberMe: false,
    isActive: false,
    openSearch: false,
    fullscreen: true,
    search: '',
    loading: false,
    changePasswordUserId: '',
    newPassword: '',
    confirmNewPassword: '',
    apiUrl: process.env.ROOT_API,
    regData: {},
    forgotPasswordInputText: '',
    show: false,
    isLogged: false,
    dialog: false,
    loginModal: false,
    forgotModal: false,
    modalNewPassword: false,
    logEmail: '',
    logPass: '',
    showRequestAlert: false,
    notifSound: '../../static/definite.mp3',
    loginModalAlert: {
      value: false,
      type: 'error',
      text: '',
      inactiveUser: false
    },
    regModalAlert: {
      value: false,
      type: 'error',
      text: '',
      isConfirmEmail: false
    },
    userInfo: {
      name: 'R Bowers'
    },
    userMenu: {
      isActive: false
    },
    mobileSearch: false,
    isAdmin: false,
    menuListItems: []
  }),
  mounted () {
    const forgotPasswordCode = this.$route.query.code
    if (forgotPasswordCode) {
      this.$store.dispatch('profile/forgotPasswordBoolean', forgotPasswordCode)
        .then(response => {
          if (response.type === 'success') {
            this.modalNewPassword = true
            this.changePasswordUserId = response.userId
          } else {
            this.$router.push('/')
          }
        })
        .catch(error => console.log(error))
    }
  },
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      signUpData: state => state.auth.userData,
      languages: state => state.common.languages,
      notifications: state => state.profile.notifications,
      newNotificationsCount: state => state.profile.newNotificationsCount
    }),
    profileItemList () {
      return [
        { icon: 'icon-my-account', title: 'my_account', path: `/accounts/${this.signUpData.id}`, tabRoute: 0 },
        { icon: 'icon-notifications', title: 'notifications', count: this.newNotificationsCount, path: '/profile/notifications', tabRoute: 3 },
        { icon: 'icon-favorites', title: 'favorites', path: '/products' },
        { icon: 'icon-goods', title: 'my_goods', path: '/profile/my-products', tabRoute: 1 },
        { icon: 'settings', title: 'settings.settings', path: '/profile/settings', tabRoute: 5 },
        { icon: 'add', title: 'profile.add_need', path: '/profile/add-needs', tabRoute: 6 },
        { icon: 'icon-friends', title: 'my_friends', path: '/profile/my-friends', tabRoute: 2 },
        { icon: 'icon-group-small', title: 'group.group', path: '/profile/my-groups', tabRoute: 4 },
        { icon: 'icon-logout', title: 'logout', path: '/logout' }
      ]
    },
    phoneNumberRules () {
      return [
        v => !!v || this.$t('pnone_required'),
        v => (!v || /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('phone_not_valid')
      ]
    },
    companyNameRules () {
      return [v => !!v || this.$t('company_name_required')]
    },
    nameRules () {
      return [v => !!v || this.$t('first_name_required'),
        v => (!/[\d`~!@#$%^&*()_|+\-=?;:'",.<>[\]\\]/.test(v)) || this.$t('first_name_rule')]
    },
    checkbox () {
      return [v => !!v || this.$t('agree_terms')]
    },
    lastNameRules () {
      return [v => !!v || this.$t('last_name_required'),
        v => (!/[\d`~!@#$%^&*()_|+\-=?;:'",.<>[\]\\]/.test(v)) || this.$t('last_name_rule')]
    },
    exEmailRules () {
      return [
        v => !!v || this.$t('email_required'),
        v => /.+@.+/.test(v) || this.$t('email_not_valid')
      ]
    },
    exEmailRulesLogin () {
      return [
        v => !!v || this.$t('email_required')
      ]
    },
    accoundPassword () {
      return [v => !!v || this.$t('account_password_required')]
    },
    accoundPasswordReg () {
      return [v => !!v || this.$t('account_password_required'),
        v => ((/^(?=.*[a-z]).+$/.test(v) &&
          /^(?=.*[A-Z]).+$/.test(v) &&
          /^(?=.*[\d]).+$/.test(v) &&
          /([-+=_!@#$%^&*.,;:'"<>/?`~[\]\\\s])/.test(v) &&
          /^.{8,}/.test(v)) || this.$t('pass_rules'))
      ]
    },
    confirmPassword () {
      return [v => v === this.regData.password || this.$t('confirm_password')]
    },

    accoundPassword2 () {
      return [v => !!v || this.$t('account_password_required')]
    },
    confirmPassword2 () {
      return [v => v === this.newPassword || this.$t('confirm_password')]
    },

    langIcon () {
      const activeLanguage = this.$store.getters['common/getActiveLanguage']
      if (activeLanguage && activeLanguage.code) {
        return 'g-language-' + activeLanguage.code
      } else {
        return 'g-language-en'
      }
    },
    langName () {
      const activeLanguage = this.$store.getters['common/getActiveLanguage']
      if (activeLanguage && activeLanguage.name) {
        return activeLanguage.name
      } else {
        return 'English'
      }
    },
    sideBarStatus () {
      return {
        opened: this.$store.state.sidebar.sidebarIsOpen
      }
    }
  },
  watch: {
    showRegistrationModal: function () {
      this.openRegistrationModal()
    },
    showLoginModal: function () {
      this.openLoginModal()
    },
    productRequestAlert: function () {
      this.openLoginModal()
      this.showRequestAlert = true
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    newNotification: function (data) {
      this.getUserNotifications()
        .then(res => {
          // const {userId, type, message} = data
          const audio = new Audio(this.notifSound)
          audio.play()
          // Let's try to send notification
          this.$toastr('info', this.$t('socket.' + data['message']))
          if (window.Notification && Notification.permission === 'granted') {
            const n = new Notification(this.$t('socket.' + data['message']), {tag: this.$t('info')})
            n.onclick = function (ev) {
              window.focus()
              this.close()
            }
          }
        })
        .catch(console.error)
    },
    logoutBlockUser: function () {
      this.toasterBlockMessage()
      this.logoutDeactivateUser()
    }
  },
  methods: {
    selectRegPerson () {
      if (this.regData.comp) {
        this.regData.comp = false
      }
    },
    noScroll () {
      window.scrollTo(0, 0)
    },
    logoutDeactivateUser () {
      this.$store.dispatch('auth/signOut')
      this.$store.dispatch('profile/clearUserData')
      this.$store.dispatch('profile/clearCategories')
      this.$router.push('/')
    },
    checked (e) {
      if (e.target.checked) {
        this.ckderror = ''
      } else {
        this.ckderror = this.$t('agree_terms')
      }
    },
    confirmationResend () {
      let email = {
        email: this.logEmail
      }
      this.$store.dispatch('auth/confirmationResend', email)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          this.showSend = false
          this.closeLoginForm()
        })
        .catch(console.error)
    },
    getFilterStatus () {
      return this.$refs.searchMain && this.$refs.searchMain.menu
    },
    openMobileSearch () {
      this.mobileSearch = !this.mobileSearch
      console.log(this.$refs.mobSearchField)
    },
    openNav () {
      this.$store.dispatch('sidebar/openSidebar')
    },
    closeNav () {
      this.$store.dispatch('sidebar/closeSidebar')
    },
    regValidate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    logValidate () {
      if (this.$refs.formLogin.validate()) {
        this.snackbar = true
      }
    },
    forgotValidate () {
      if (this.$refs.formForgot.validate()) {
        this.snackbar = true
      }
    },
    forgotPasswordValidate () {
      if (this.$refs.formForgotPassword.validate()) {
        this.snackbar = true
      }
    },
    languageChanged () {
      if (this.$route.name !== 'products') {
        this.categoryList()
      }
    },
    backLoginModal () {
      this.dataAllClearFunction()
      this.openLoginModal()
    },
    dataAllClearFunction () {
      this.changePasswordUserId = ''
      this.newPassword = ''
      this.confirmNewPassword = ''
      this.forgotPasswordInputText = ''
      this.show = false
      this.isLogged = false
      this.dialog = false
      this.loginModal = false
      this.forgotModal = false
      this.modalNewPassword = false
      this.logEmail = ''
      this.logPass = ''
      this.userMenu.isActive = false
    },
    closeModalNewPasswordInfo () {
      this.modalNewPassword = false
      this.$router.push('/')
    },
    sendModalNewPasswordInfo () {
      const playload = {
        newPassword: this.newPassword,
        confirmNewPassword: this.confirmNewPassword,
        userId: this.changePasswordUserId,
        code: this.$route.query.code
      }
      const _newPassword = this.newPassword
      this.$store.dispatch('profile/changeUserPassword', playload)
        .then((res) => {
          if (res.type === 'success') {
            this.dataAllClearFunction()
            this.$toastr('success', res.message, this.$t('success'))
            // login the user
            this.logPass = _newPassword
            this.logEmail = res.email
            console.log('this.logPass, this.logEmail', this.logPass, this.logEmail)
            this.signIn()
              .then(() => {
                this.$router.push('/profile/my-account')
              })
              .catch(console.error)
          } else {
            this.loginModalAlert.value = true
            this.loginModalAlert.text = res.message
            this.loginModalAlert.type = res.type
          }
        }).catch(console.error)
    },
    forgotPasswordEmailCheck () {
      this.loading = true
      this.$store.dispatch('profile/checkUserForgotPassword', this.forgotPasswordInputText)
        .then((res) => {
          if (res.type === 'success') {
            this.dataAllClearFunction()
            this.$toastr('success', res.message, this.$t('success'))
          } else {
            this.loginModalAlert.value = true
            this.loginModalAlert.text = res.message
            this.loginModalAlert.type = res.type
          }
          this.loading = false
        }).catch(console.error)
    },
    forgotPasswordModal () {
      this.loginModalAlert.value = false
      this.loginModalAlert.text = ''
      this.loginModalAlert.type = 'error'
      this.dialog = false
      this.loginModal = false
      this.rememberMe = false
      this.forgotModal = true
    },
    enterSendModalNewPasswordInfo (ele) {
      if (ele.which === 13) {
        this.sendModalNewPasswordInfo()
      }
    },
    makeToLowerCaseLogin () {
      this.logEmail = this.logEmail.toLowerCase()
    },
    makeToLowerCaseRegister () {
      this.regData.email = this.regData.email.toLowerCase()
    },
    enterKeyPressRegistration (ele) {
      if (ele.which === 13) {
        this.signUp()
      }
    },
    enterKeyPressLogin (ele) {
      if (ele.which === 13) {
        this.signIn()
      }
    },
    enterKeyPressForgotPassword (ele) {
      if (ele.which === 13) {
        this.forgotPasswordEmailCheck()
      }
    },
    productPage () {
      this.closeNav()
      EventBus.$emit('set-default-params')
      EventBus.$emit('delete-search-autocomplete')
      this.$store.dispatch('categories/setFavorite', {favorite: false})
      this.$router.push({name: 'products', query: {page: 1, limit: 8}})
    },
    getInTouchPage () {
      if (this.$route.name !== 'WelcomePage') {
        this.$router.push({name: 'WelcomePage'})
        setTimeout(() => {
          const container = document.getElementById('contact')
          if (container) {
            container.scrollIntoView({behavior: 'smooth'})
          }
        }, 0)
      } else {
        const container = document.getElementById('contact')
        container.scrollIntoView({behavior: 'smooth'})
      }
    },

    setLang (lang) {
      this.$store.dispatch('common/setLang', lang.code).then(() => {
        // this.langIcon = 'g-language-' + lang.code
        (lang.code === 'hy') ? this.$moment.locale('hy-am') : this.$moment.locale('en')
        EventBus.$emit('language-changed', lang)
        if (this.$route.name !== 'products') {
          this.categoryList()
        }
      }).catch(console.error)
    },
    openRegistrationModal () {
      window.addEventListener('scroll', this.noScroll)
      this.regData = {}
      this.hideCompany = true
      this.closeNav()
      this.regModalAlert.value = false
      this.regModalAlert.isConfirmEmail = false
      this.loginModal = false
      this.rememberMe = false
      this.dialog = true
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.checkRouteName()
      /* todo for the future need to use roles
        this.$store.dispatch('common/gatRegistrationRoles').then((res) => {
          this.roles = res.regRoles
          this.dialog = true
          // this need for hide already existed alert messages
        }).catch(console.error)
      */
    },
    closeRegForm () {
      window.removeEventListener('scroll', this.noScroll)
      this.regModalAlert.isConfirmEmail = false
      this.dialog = false
      this.ckderror = ''
      this.regData = {}
    },
    openLoginModal () {
      window.addEventListener('scroll', this.noScroll)
      this.closeNav()
      this.checkRouteName()
      this.loginModalAlert.value = false // this need for hide already existed alert messages
      this.loginModalAlert.inactiveUser = false // this need for hide already existed alert messages
      this.showRequestAlert = false
      this.dialog = false
      this.loginModal = true
    },
    closeLoginForm () {
      window.removeEventListener('scroll', this.noScroll)
      this.$refs.formLogin.reset()
      this.$refs.formLogin.resetValidation()
      this.loginModal = false
      this.rememberMe = false
      this.showSend = false
    },
    signIn () {
      window.removeEventListener('scroll', this.noScroll)
      this.loginModalAlert.value = false // this need for hide already existed alert messages
      this.loginModalAlert.inactiveUser = false // this need for hide already existed alert messages
      let data = {}
      data.email = this.logEmail
      data.password = this.logPass
      data.rememberMe = this.rememberMe

      return this.$store.dispatch('auth/signIn', data).then((res) => {
        if (res.errors) {
          this.loginErrors = res.errors
        }
        if (res.token) {
          localStorage.setItem('token', res.token)
          let decodedUser = VueJwtDecode.decode(res.token)
          localStorage.setItem('expTime', decodedUser['exp'])
          this.loginModal = false
          this.rememberMe = false
          setAuthHeader(res.token)
          this.getUserNotifications()
          this.getMenuListItems()
          let pathBeforeLogin = '/'
          if (localStorage.getItem('routePath')) {
            pathBeforeLogin = localStorage.getItem('routePath')
            localStorage.removeItem('routePath')
          }
          this.$socket.emit('authentication', {token: res.token}) // this part need for add logged user id into socket
          this.$router.push(pathBeforeLogin)
        } else if (res.message) { // something went wrong
          this.loginModalAlert.value = true
          this.loginModalAlert.text = res.message
          this.showSend = false
          if (res.resend) {
            this.showSend = true
          }
          this.loginModalAlert.type = res.type
          if (res.inactiveUser) {
            this.loginModalAlert.inactiveUser = res.inactiveUser
          }
        }
        // here we have changed this.signUpData from auth state
      }).catch((err) => {
        console.log('err', err)
        return err.response
      })
    },
    signUp () {
      window.removeEventListener('scroll', this.noScroll)
      this.regModalAlert.value = false // this need for hide already existed alert messages
      this.regModalAlert.isConfirmEmail = false
      let _err = ''
      if (!this.regData.checkbox) {
        this.ckderror = this.$t('agree_terms')
      }
      if (!validateEmail(this.regData.email)) {
        _err += this.$t('invalid_email') + '<br />'
      }
      if (this.regData.password !== this.regData.password_confirmation) {
        _err += this.$t('password_doesnt_match') + '<br />'
      }
      if (_err !== '') {
        this.regModalAlert.value = true
        this.regModalAlert.text = _err
        this.regModalAlert.type = 'error'
        return false
      }
      this.$store.dispatch('auth/signUp', this.regData).then((res) => {
        if (res.errors) {
          this.errors = res.errors
        }
        if (res.token) {
          localStorage.setItem('token', res.token)
          this.dialog = false
          setAuthHeader(res.token) // important for add token into header
          this.$socket.emit('authentication', {token: res.token}) // this part need for add logged user id into socket
          this.$router.push('/profile')
        } else if (res.message) { // something went wrong
          this.hideCompany = false
          this.regModalAlert.value = true
          this.regModalAlert.text = res.message
          this.regModalAlert.type = res.type
          if (res.isConfirmEmail) {
            this.regModalAlert.isConfirmEmail = res.isConfirmEmail
          }
        } else if (res.data && res.data.errors && res.data.errors.length > 0) {
          let _errors = ''
          res.data.errors.forEach(err => {
            if (err.message_code) {
              _errors += this.$t(err.message_code) + '<br>'
            } else {
              _errors += err.message + '<br>'
            }
          })
          this.regModalAlert.value = true
          this.regModalAlert.text = _errors
          this.regModalAlert.type = 'error'
        }
      }).catch(console.error)
    },
    profileStaticFunction (event, path, tabRoute) {
      if (path !== '/logout') {
        if (path === '/products') {
          this.$router.push({name: 'products'})
          this.$store.dispatch('categories/setFavorite', {favorite: true})
          EventBus.$emit('select-favorite')
        }
        if (this.newNotificationsCount && path === '/profile/notifications') {
          this.$store.dispatch('profile/hideNotificationCount').then((res) => {
          }).catch(console.error)
        }
        setAuthHeader(localStorage.getItem('token')) // important for add token into header
        this.$emit('changeActive', tabRoute)
        this.$router.push(path)
      } else {
        this.logOut()
      }
    },
    getUserNotifications () {
      return this.$store.dispatch('profile/getUserNotifications').then((res) => {
        return res
      }).catch(console.error)
    },
    deleteNotification (item) {
      this.$store.dispatch('profile/deleteNotification', item).then((res) => {
        this.$toastr(res.type, res.message, this.$t(res.type))
      }).catch(console.error)
    },
    logOut () {
      this.$store.dispatch('auth/signOut')
      this.$store.dispatch('profile/clearUserData')
      this.$store.dispatch('profile/clearCategories')
      // this.$store.dispatch('categories/clearList')
      this.dataAllClearFunction()
      this.$router.push('/')
    },
    resendConfirmationCode () {
      if (validateEmail(this.logEmail)) {
        this.$store.dispatch('auth/resendConfirmationCode', {email: this.logEmail})
          .then((res) => {
            if (res.data.resendConfirmEmail) {
              this.$toastr(res.data.type, res.data.message, this.$t(res.data.type))
            }
          })
          .catch(console.error)
      }
    },
    checkRouteName () {
      if (this.$route.name === 'product') {
        localStorage.setItem('routePath', this.$route.path)
      }
    },
    getLanguageName (name) {
      let value = ''
      if (this.settings && this.settings.length > 0) {
        this.settings.forEach(setting => {
          if (setting.name === name) {
            value = setting.value
          }
        })
      }
      return value
    },
    categoryList () {
      this.$store.dispatch('categories/listWithSubCategories', {changeListState: true}).then(res => {})
    },
    toasterBlockMessage () {
      this.$toastr('add', {
        title: this.$t('account_deactivated') + '<br><br>',
        msg: this.$t('deactivated_message') + ' ' + '<i><a style="text-decoration: underline" href="https://giver.am/contact">' + this.$t('here') + '</a></i>' + ' ' + this.$t('deactivated_message_1'),
        timeout: 100000,
        position: 'toast-bottom-left',
        type: 'error',
        clickClose: true
      })
    },
    getMenuListItems () {
      this.isAdmin = decodeJwtToken().includes('admin')
      this.menuListItems = this.profileItemList
      if (!this.isAdmin) {
        this.menuListItems = this.profileItemList.filter(el => (!el.path.includes('profile/settings')) && (!el.path.includes('profile/add-needs')))
      }
    }
  },
  beforeUpdate () {
    this.isLogged = !!(localStorage && localStorage.getItem('token'))
  },
  beforeMount () {
    if (this.$router.currentRoute.query['signed_token_fb_or_google']) {
      localStorage.setItem('token', this.$router.currentRoute.query['signed_token_fb_or_google'])
      if (localStorage.getItem('token')) {
        let token = localStorage.getItem('token')
        let decodedUser = VueJwtDecode.decode(token)
        localStorage.setItem('expTime', decodedUser['exp'])
        let pathBeforeLogin = '/'
        if (localStorage.getItem('routePath')) {
          pathBeforeLogin = localStorage.getItem('routePath')
          localStorage.removeItem('routePath')
        }
        setTimeout(() => {
          window.location.reload()
          this.isLogged = true
        }, 0)
        this.$router.push(pathBeforeLogin)
      }
    } else if (this.$router.currentRoute.query['confirmationPage']) {
      if (localStorage.getItem('token')) {
        this.$router.push('/profile/notifications')
      } else {
        this.loginModal = true
      }
      let token = this.$router.currentRoute.query['confirmationPage']
      if (token) {
        try {
          let decodedUser = VueJwtDecode.decode(token)
          setTimeout(() => {
            if (!this.signUpData.id) {
              return
            }
            let userIsGuest = decodedUser.isGuest
            if (userIsGuest) {
              this.openRegistrationModal()
              this.regData.realInviteEmail = decodedUser.userEmail
              this.regData.email = decodedUser.userEmail
              this.regData.inviterMail = decodedUser.inviterMail
              this.regData.inviterId = decodedUser.inviterId
              this.regModalAlert.text = this.$t('pleaseRegForConfirm')
              this.regModalAlert.type = 'warning'
              this.regModalAlert.value = true
            } else {
              this.openLoginModal()
              this.logEmail = decodedUser.userEmail
              this.loginModalAlert.text = this.$t('pleaseLogForConfirm')
              this.loginModalAlert.type = 'warning'
              this.loginModalAlert.value = true
            }
          }, 1000)
        } catch (e) {
          console.log('e', e.message)
        }
      }
    } else {
      if (this.$router.currentRoute.query['fb_or_google_sign_in_issue']) {
        setTimeout(() => {
          // Make a toastr with custom properties
          this.$toastr('add', {
            title: this.$root.$t('warning'), // Toast Title
            msg: this.$root.$t('headers.fb_user_email_issue'), // Message
            timeout: 100000, // Timeout in ms
            position: 'toast-bottom-left', // Toastr position
            type: 'warning', // Toastr type
            clickClose: true // On click toast close can be boolean; default false
          })
          this.$router.push('/')
        }, 1000)
      }
      if (this.$router.currentRoute.query['user_blocked_by_admin']) {
        setTimeout(() => {
          this.toasterBlockMessage()
          this.$router.push('/')
        }, 1000)
      }
    }
    if (localStorage && localStorage.getItem('token')) {
      this.isLogged = true
      this.getUserNotifications()
    }
    this.$store.dispatch('auth/userInfo')
      .then((res) => {
        this.getMenuListItems()
      })
      .catch(console.error)
  },
  created () {
    this.categoryList()
    EventBus.$on('language-changed', this.languageChanged)
  },
  metaInfo () {
    document.head.querySelector('meta[name=description]').content = this.$root.$t('header.site_description')
    document.head.querySelector('meta[name=keywords]').content = this.$root.$t('header.site_keywords')
    // return {
    //   meta: [
    //     { name: 'keywords', content: this.$root.$t('header.site_keywords') },
    //     { name: 'description', content: this.$root.$t('header.site_description') }
    //   ]
    // }
  }
}
</script>

<style lang="scss">
  a {
    text-decoration: none;
  }
  a.one:link {
    text-decoration: underline!important;
    font-size: 14px;
  }
  .errormessage {
    color: #ff1744;
    font-size: 11px;
  }
  input[type="checkbox"] {
    -moz-appearance: none;
  }

  @media all and (max-width: 480px) {
    input[type="checkbox"] {
      width: 15px;
      height: 15px;
    }
   .errormessage {
     margin-left: 9px;
   }
    a.one:link {
      text-decoration: underline!important;
      font-size: 9px;
    }
    .agree {
      font-size: 10px;
      margin-top: 3px;
    }
  }
.checkbox{
   width:17px;
   height: 17px;
}
.donate-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 4px;
    transform: translateY(-2px);
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("../../assets/images/icons/heart__4__2.svg");
}
    @import "../../assets/sass/desktop/header.scss";
</style>



// WEBPACK FOOTER //
// src/components/global/Header.vue